import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  badge: {
    justifyContent: "flex-start",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "15px",
  },
  button: {
    cursor: "pointer",
  },
}));

export default styles;
